import { __assign } from 'tslib';
import React__default, { useCallback } from 'react';
import { currentFolderRootBreadcrumbContext } from '@keepeek/commons';
import { useTheme, useMediaQuery, LinearProgress, Box, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import KBreadcrumb from '../index.js';
import KButton from '../../KButtons/index.js';
import { useBreadcrumb } from '../../providers/breadcrumb/hooks.js';
import '../../providers/breadcrumb/atoms.js';
import '../../KMosaic/KMosaicElement/index.props.js';
import '../../providers/mosaic/atoms.js';
import '../../providers/mosaic/selectors.js';
import 'lodash/uniq';
import KFolderBrowse from '../KFolderBrowse/index.js';

var KFolderBreadcrumb = function KFolderBreadcrumb(_a) {
    var _b, _c;
    var _d = _a.breadcrumbKey, breadcrumbKey = _d === void 0 ? "KFolderBreadcrumb" : _d, folderId = _a.folderId, className = _a.className, initFolderRootId = _a.initFolderRootId, home = _a.home, clientIp = _a.clientIp, showFolderCover = _a.showFolderCover, showSubFolderLink = _a.showSubFolderLink, showMainActionLink = _a.showMainActionLink, showFolderOnArrival = _a.showFolderOnArrival, breadcrumbRootFolderId = _a.breadcrumbRootFolderId, changeDataViewOnClick = _a.changeDataViewOnClick, loadingImageOptim = _a.loadingImageOptim, shouldOptimizeImage = _a.shouldOptimizeImage, setActiveFilters = _a.setActiveFilters, KIcon = _a.KIcon, EditableSanitizeHtml = _a.EditableSanitizeHtml, ImageOptim = _a.ImageOptim, sentryCallback = _a.sentryCallback, foldersAuthorizedId = _a.foldersAuthorizedId, homeIcon = _a.homeIcon, defaultKBreadcrumbItem = _a.defaultKBreadcrumbItem, sx = _a.sx, _e = _a.hideHideButton, hideHideButton = _e === void 0 ? false : _e;
    var t = useTranslation("refront-components").t;
    var setCurrentFolderRoot = useSetRecoilState(currentFolderRootBreadcrumbContext);
    var _f = useBreadcrumb({
        initFolderId: folderId,
        initFolderRootId: breadcrumbRootFolderId || initFolderRootId,
        initialShowFolders: showFolderOnArrival,
        key: breadcrumbKey,
        clientIp: clientIp,
        showSubFolderLink: showSubFolderLink,
        rootFolderIds: foldersAuthorizedId,
        setActiveFilters: setActiveFilters,
        sentryCallback: sentryCallback
    }), folders = _f.folders, folderTree = _f.folderTree, foldersVisible = _f.foldersVisible, handleHideButton = _f.handleHideButton, handleFolderClick = _f.handleFolderClick, openFolder = _f.openFolder, search = _f.search, loadingFolderTree = _f.loading;
    var theme = useTheme();
    var isDownSm = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var hasSubFolder = (folderTree === null || folderTree === void 0 ? void 0 : folderTree.children) && ((_b = folderTree.children) === null || _b === void 0 ? void 0 : _b.length) > 0;
    var _handleButtonSearch = useCallback(function (id) {
        var correspondingFolder = folders === null || folders === void 0 ? void 0 : folders.find(function (f) { return f.id === id; });
        if (!correspondingFolder) {
            // Fallback
            search({ folderId: id, extraParams: { fc: id } });
        }
        else {
            // Nominal case
            search({
                folderId: correspondingFolder.id,
                extraParams: { fc: correspondingFolder.id },
                folderTitle: correspondingFolder.title,
                treeMediaCount: correspondingFolder.treeMediaCount
            });
        }
    }, [folders, search]);
    // Hide if no folder id is specified and we don't have foldersAuthorizedId
    // If foldersAuthorizedId undefined, all first level folders are displayed
    if (!folderId && foldersAuthorizedId && foldersAuthorizedId.length === 0) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        loadingFolderTree && (React__default.createElement(LinearProgress, { sx: {
                marginBottom: -0.5
            } })),
        React__default.createElement(Box, { className: clsx("KFolderBreadcrumb", className) },
            React__default.createElement(Box, { sx: __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", padding: theme.spacing(1) }, sx) },
                React__default.createElement(KBreadcrumb, { items: (folders === null || folders === void 0 ? void 0 : folders.map(function (folder) {
                        var _a;
                        return ({
                            id: folder.id.toString(),
                            label: (_a = folder === null || folder === void 0 ? void 0 : folder.title) !== null && _a !== void 0 ? _a : "",
                            onClick: function (id) {
                                openFolder(parseInt(id));
                                if (changeDataViewOnClick) {
                                    _handleButtonSearch(Number(id));
                                }
                            }
                        });
                    })) || [], buttonLabel: t("components.home.widget.mosaic.breadcrumb.button-see-all.label"), onButtonClick: function (id) { return _handleButtonSearch(Number(id)); }, loading: !folders && folderId !== undefined, home: home, sx: sx, KIcon: KIcon, homeIcon: homeIcon, defaultKBreadcrumbItem: defaultKBreadcrumbItem, hideViewAllButton: changeDataViewOnClick }),
                !hideHideButton && !isDownSm && hasSubFolder && (React__default.createElement(KButton, { size: "small", variant: "outlined", buttonName: "hide-folders", onClick: function () { return handleHideButton(foldersVisible); }, title: foldersVisible
                        ? t("components.home.widget.mosaic.detail.button-hide.label")
                        : t("components.home.widget.mosaic.detail.button-unhide.label") },
                    React__default.createElement(KIcon, { sx: { marginRight: "8px" }, className: "fa-solid ".concat(foldersVisible ? "fa-eye-slash" : "fa-eye", " fa-lg") }),
                    foldersVisible ? (EditableSanitizeHtml ? (React__default.createElement(EditableSanitizeHtml, { labelKey: "components.home.widget.mosaic.detail.button-hide.label", namespace: "refront-components" })) : (t("components.home.widget.mosaic.detail.button-hide.label"))) : EditableSanitizeHtml ? (React__default.createElement(EditableSanitizeHtml, { labelKey: "components.home.widget.mosaic.detail.button-unhide.label", namespace: "refront-components" })) : (t("components.home.widget.mosaic.detail.button-unhide.label")))),
                !hideHideButton && isDownSm && hasSubFolder && (React__default.createElement(IconButton, { "data-testid": "hide-folders", size: "medium", onClick: function () { return handleHideButton(foldersVisible); }, className: "IconButton-hide-folders", "aria-label": t("components.home.widget.mosaic.detail.button-hide.label"), color: "primary", sx: {
                        alignSelf: "center",
                        marginLeft: 1
                    }, title: foldersVisible
                        ? t("components.home.widget.mosaic.detail.button-hide.label")
                        : t("components.home.widget.mosaic.detail.button-unhide.label") },
                    React__default.createElement(KIcon, { sx: { fontSize: "1rem" }, className: "fa-solid ".concat(foldersVisible ? "fa-eye-slash" : "fa-eye") })))),
            !loadingImageOptim &&
                foldersVisible &&
                (folderTree === null || folderTree === void 0 ? void 0 : folderTree.children) &&
                ((_c = folderTree.children) === null || _c === void 0 ? void 0 : _c.length) > 0 && (React__default.createElement(KFolderBrowse, { folders: folderTree.children, onFolderClick: function (_a) {
                    var _b;
                    var id = _a.id;
                    var folderFound = (_b = folderTree.children) === null || _b === void 0 ? void 0 : _b.find(function (f) { return f.id === id; });
                    handleFolderClick({
                        folderId: id,
                        changeDataViewOnClick: changeDataViewOnClick,
                        folderTitle: folderFound === null || folderFound === void 0 ? void 0 : folderFound.title,
                        treeMediaCount: folderFound === null || folderFound === void 0 ? void 0 : folderFound.treeMediaCount
                    });
                    if (foldersAuthorizedId === null || foldersAuthorizedId === void 0 ? void 0 : foldersAuthorizedId.includes(id)) {
                        setCurrentFolderRoot(id);
                    }
                }, onSubFolderClick: function (_a) {
                    var id = _a.id;
                    openFolder(id);
                    if (foldersAuthorizedId === null || foldersAuthorizedId === void 0 ? void 0 : foldersAuthorizedId.includes(id)) {
                        setCurrentFolderRoot(id);
                    }
                }, loading: !folderTree, showFolderCover: showFolderCover, showSubFolderLink: showSubFolderLink, showMainActionLink: showMainActionLink, imageComponent: {
                    active: shouldOptimizeImage && showFolderCover,
                    component: function (src, className, alt) {
                        if (!src) {
                            return null;
                        }
                        var img = (React__default.createElement("img", { src: src, className: className, alt: alt || "", width: theme.spacing(8).replace("px", ""), height: theme.spacing(8).replace("px", "") }));
                        return ImageOptim
                            ? ImageOptim(src, className || "KFolderBreadcrumbImageOptim", alt || "", Number(theme.spacing(8).replace("px", "")), Number(theme.spacing(8).replace("px", "")), img)
                            : img;
                    }
                }, KIcon: KIcon, sx: __assign({ padding: theme.spacing(1, 1, 2, 1) }, sx) })))));
};

export { KFolderBreadcrumb as default };
//# sourceMappingURL=index.js.map
